export { HOOK_EVENT as VGRAMMAR_HOOK_EVENT } from "@visactor/vgrammar-core";

export const BASE_EVENTS = [ "pointerdown", "pointerup", "pointerupoutside", "pointertap", "pointerover", "pointermove", "pointerenter", "pointerleave", "pointerout", "mousedown", "mouseup", "mouseupoutside", "rightdown", "rightup", "rightupoutside", "click", "dblclick", "mousemove", "mouseover", "mouseout", "mouseenter", "mouseleave", "wheel", "touchstart", "touchend", "touchendoutside", "touchmove", "touchcancel", "tap", "dragstart", "drag", "dragenter", "dragleave", "dragover", "dragend", "drop", "pan", "panstart", "panend", "press", "pressup", "pressend", "pinch", "pinchstart", "pinchend", "swipe" ];

export var ChartEvent;

!function(ChartEvent) {
    ChartEvent.initialized = "initialized", ChartEvent.rendered = "rendered", ChartEvent.renderFinished = "renderFinished", 
    ChartEvent.animationFinished = "animationFinished", ChartEvent.regionSeriesDataFilterOver = "regionSeriesDataFilterOver", 
    ChartEvent.afterInitData = "afterInitData", ChartEvent.afterInitEvent = "afterInitEvent", 
    ChartEvent.afterInitMark = "afterInitMark", ChartEvent.rawDataUpdate = "rawDataUpdate", 
    ChartEvent.viewDataFilterOver = "viewDataFilterOver", ChartEvent.viewDataUpdate = "viewDataUpdate", 
    ChartEvent.viewDataStatisticsUpdate = "viewDataStatisticsUpdate", ChartEvent.markDeltaYUpdate = "markDeltaYUpdate", 
    ChartEvent.viewDataLabelUpdate = "viewDataLabelUpdate", ChartEvent.scaleDomainUpdate = "scaleDomainUpdate", 
    ChartEvent.scaleUpdate = "scaleUpdate", ChartEvent.dataZoomChange = "dataZoomChange", 
    ChartEvent.drill = "drill", ChartEvent.layoutStart = "layoutStart", ChartEvent.layoutEnd = "layoutEnd", 
    ChartEvent.layoutRectUpdate = "layoutRectUpdate", ChartEvent.playerPlay = "playerPlay", 
    ChartEvent.playerPause = "playerPause", ChartEvent.playerEnd = "playerEnd", ChartEvent.playerChange = "playerChange", 
    ChartEvent.playerForward = "playerForward", ChartEvent.playerBackward = "playerBackward", 
    ChartEvent.scrollBarChange = "scrollBarChange", ChartEvent.brushStart = "brushStart", 
    ChartEvent.brushChange = "brushChange", ChartEvent.brushEnd = "brushEnd", ChartEvent.brushClear = "brushClear", 
    ChartEvent.legendSelectedDataChange = "legendSelectedDataChange", ChartEvent.legendFilter = "legendFilter", 
    ChartEvent.legendItemClick = "legendItemClick", ChartEvent.legendItemHover = "legendItemHover", 
    ChartEvent.legendItemUnHover = "legendItemUnHover", ChartEvent.tooltipShow = "tooltipShow", 
    ChartEvent.tooltipHide = "tooltipHide", ChartEvent.tooltipRelease = "tooltipRelease", 
    ChartEvent.afterResize = "afterResize", ChartEvent.afterRender = "afterRender", 
    ChartEvent.afterLayout = "afterLayout";
}(ChartEvent || (ChartEvent = {}));

export var Event_Source_Type;

!function(Event_Source_Type) {
    Event_Source_Type.chart = "chart", Event_Source_Type.window = "window", Event_Source_Type.canvas = "canvas";
}(Event_Source_Type || (Event_Source_Type = {}));

export var Event_Bubble_Level;

!function(Event_Bubble_Level) {
    Event_Bubble_Level.vchart = "vchart", Event_Bubble_Level.chart = "chart", Event_Bubble_Level.model = "model", 
    Event_Bubble_Level.mark = "mark";
}(Event_Bubble_Level || (Event_Bubble_Level = {}));
//# sourceMappingURL=event.js.map